<script lang="ts">
	import { onMount } from 'svelte';
	import { acceptTracking, declineTracking, hasConsentDecision } from '$lib/services/analytics';
	import { t } from 'svelte-i18n';

	let visible = $state(false);

	onMount(() => {
		if (!hasConsentDecision()) {
			visible = true;
		}
	});

	function accept() {
		acceptTracking();
		visible = false;
	}

	function decline() {
		declineTracking();
		visible = false;
	}
</script>

{#if visible}
	<div class="fixed bottom-0 left-0 z-50 w-screen border-t border-(--border) bg-(--card) shadow-(--shadow-card)">
		<div class="mx-auto flex max-w-4xl flex-col gap-3 p-4 sm:flex-row sm:items-center sm:justify-between">
		<p class="text-sm text-(--foreground)">
			{$t('cookie.message')}
		</p>
		<div class="flex shrink-0 gap-2">
			<button
				onclick={decline}
				class="rounded-full border border-(--border) bg-transparent px-4 py-1.5 text-sm text-(--foreground) transition-colors hover:bg-(--muted)"
			>
				{$t('cookie.decline')}
			</button>
			<button
				onclick={accept}
				class="rounded-full bg-(--accent-green) px-4 py-1.5 text-sm font-medium text-(--primary-foreground) transition-opacity hover:opacity-90"
			>
				{$t('cookie.accept')}
			</button>
		</div>
		</div>
	</div>
{/if}
